export default __webpack_public_path__ + "static/media/lagos ajah.9ec2b2bb.jpg";